
import { Vue, Component, Watch, Prop, Model } from 'vue-property-decorator';

@Component
export default class SearchBar extends Vue {
  @Prop({ default: '请输入姓名或作品名称' }) placeholder!: string;
  @Model('userInputChange', { type: String }) keyword!: string;

  userInput = '';

  @Watch('userInput')
  onKeywordChange(newval: string) {
    this.$emit('userInputChange', newval);
    if (!newval.length) {
      this.$emit('clear');
    }
  }

  // get userKeyword() {
  //   return this.keyword;
  // }

  // set userKeyword(val: string) {
  //   console.log('keyword updating', val);
  // }
}
